import {Module} from 'vuex';
import {UserState} from './types';
import {mutations} from './mutations';
import {actions} from './actions';
import {RootState} from '@/store/types';
import {getters} from '@/store/User/getters';

const state: UserState = {
    otherdiagnosis : undefined,
    diagnosis: undefined,
    userType: undefined,
    self: undefined,
    selfRef: undefined,
    funStuff: undefined,
    distance: undefined,
    transactions: undefined,
    groupFunStuff: undefined,
    purchases: undefined,
    isBanned: undefined,
};
const namespaced: boolean = true;

export const userState: Module<UserState, RootState> = {
    namespaced,
    state,
    actions,
    getters,
    mutations,
};
